import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import sharedStyle from '../style.module.less';
import style from './style.module.less';

export const LabelBatchNoOrdersIncluded = ({ modalFrameworkMethods }) => {
  const { closeModal } = modalFrameworkMethods;
  return (
    <React.Fragment>
      <ModalHeader closeModal={closeModal}>
        <FormattedMessage defaultMessage='No Orders to Process' description='labelBatch.noOrdersIncludedHeader' id='aeMl5e' />
      </ModalHeader>
      <ModalBody className={classnames(sharedStyle['batch-processing-modal'], style['no-orders-body'])}>
        <div className={style['no-orders-message']}>
          <FormattedMessage defaultMessage='All of the Orders have been removed.' description='labelBatch.noOrdersIncluded' id='aFxPmu' />
        </div>
      </ModalBody>
      <ModalFooter className={sharedStyle['batch-processing-modal-footer']}>
        <Button onClick={closeModal} theme={THEME_CONSTANTS.tertiary}>
          <FormattedMessage defaultMessage='Close' description='noOrdersIncluded.close' id='+/vQtb' />
        </Button>
      </ModalFooter>
    </React.Fragment>
  );
};

LabelBatchNoOrdersIncluded.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
};
